import UserStore from "../store/UserStore";

export const filterDraftArticles: <
  T extends Nullable<ArticleResponse[]> | Nullable<ArticleResponse>
>(
  list: T
) => T = (entity) => {
  const { isAuth } = UserStore;

  if (Array.isArray(entity)) {
    return isAuth ? (entity as any) : entity.filter((item) => !item.is_draft);
  } else {
    return isAuth ? entity : entity?.is_draft ? null : entity;
  }
};
